import React from "react";
import "../../style";


export default class Button extends React.Component {
  render() {
    let isdisabled = this.props.disabled;
    return (
      <div>
        <button
          style={{ outline: "none" }}
          onClick={this.props.onclick}
          disabled={isdisabled}
          className={`element_button ${this.props.styleClass}`}
        >
          {this.props.name}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormElement/Button.js